import angular from 'angular'

export function UserAPIKeysCtrl(
  $scope,
  $routeParams,
  $translate,
  logger,
  userKeysService,
  keyStatusService,
  apiAuthorizationService,
  permissions
) {
  'ngInject'

  angular.extend($scope, {
    model: {
      organization: {
        id: $routeParams.orgUuid,
        name: '',
        isSuperadmin: false
      },
      apiKeyData: apiAuthorizationService.getInitialData()
    },
    userKeyStatus: {
      rotated: false
    },
    isImpersonating: permissions.isImpersonating()
  })

  angular.extend($scope, {
    rotateServiceKey,
    copyAuthHeader,
    copyAPIRequest,
    getMostPermissiveRole
  })

  init()

  function init() {
    if (!permissions.isImpersonating()) {
      _getApiKeyData()
    }
  }

  function _getApiKeyData() {
    return apiAuthorizationService
      .init()
      .then(({ apiKey, serviceKey, authHeader, teamserverURL }) => {
        $scope.model.apiKeyData.apiKey = apiKey
        $scope.model.apiKeyData.serviceKey = serviceKey
        $scope.model.apiKeyData.authHeader = authHeader
        $scope.model.apiKeyData.teamserverURL = teamserverURL
      })
  }

  function rotateServiceKey() {
    userKeysService.rotateServiceKey(_updateUserKeys)
  }

  function _updateUserKeys() {
    _getApiKeyData().then(() => {
      keyStatusService.changeKeyStatusToRotated($scope.userKeyStatus)
    })
  }

  function copyAuthHeader() {
    logger.logSuccess($translate.instant('detail_profile_authHeaderCopied'))
  }

  function copyAPIRequest() {
    logger.logSuccess($translate.instant('detail_sampleAPIRequestCopied'))
  }

  function getMostPermissiveRole() {
    return permissions.getMostPermissiveRole()
  }
}
